import styles from './index.module.css';
import { Typography } from 'antd';
import Nudge from '../../../../Models/Nudge';
import parse from 'html-react-parser';
import {
  AreaChartOutlined,
  BankOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  DollarOutlined,
  FallOutlined,
  FileTextOutlined,
  FundOutlined,
  LineChartOutlined,
  PieChartOutlined,
  RiseOutlined,
  SaveOutlined,
  ShoppingOutlined,
  StockOutlined,
  TeamOutlined,
  WalletOutlined,
  SafetyCertificateOutlined,
  CoffeeOutlined,
  BarChartOutlined,
} from '@ant-design/icons';

const iconStyle = {
  fontSize: '24px',
  color: '#fff',
};

const getIcon = (nudge: Nudge) => {
  switch (nudge.id) {
    case '1':
      return <FallOutlined style={iconStyle} />;
    case '2':
      return <SaveOutlined style={iconStyle} />;
    case '3':
      return <FundOutlined style={iconStyle} />;
    case '4':
      return <StockOutlined style={iconStyle} />;
    case '5':
      return <CalendarOutlined style={iconStyle} />;
    case '6':
      return <BankOutlined style={iconStyle} />;
    case '7':
      return <LineChartOutlined style={iconStyle} />;
    case '8':
      return <RiseOutlined style={iconStyle} />;
    case '9':
      return <ShoppingOutlined style={iconStyle} />;
    case '10':
      return <AreaChartOutlined style={iconStyle} />;
    case '11':
      return <PieChartOutlined style={iconStyle} />;
    case '12':
      return <WalletOutlined style={iconStyle} />;
    case '13':
      return <FileTextOutlined style={iconStyle} />;
    case '14':
      return <CreditCardOutlined style={iconStyle} />;
    case '15':
      return <DollarOutlined style={iconStyle} />;
    case '16':
      return <TeamOutlined style={iconStyle} />;
    case '17':
      return <SaveOutlined style={iconStyle} />;
    case '18':
      return <SafetyCertificateOutlined style={iconStyle} />;
    case '19':
      return <CoffeeOutlined style={iconStyle} />;
    case '20':
      return <BarChartOutlined style={iconStyle} />;
    default:
      return <AreaChartOutlined style={iconStyle} />;
  }
};

const getThemeClass = (nudgeId: string) => {
  // Investment nudges (4, 6, 8, 10, 12, 20)
  if (['4', '6', '8', '10', '12', '20'].includes(nudgeId)) {
    return styles.investment;
  }
  // Spending/alert nudges (1, 9, 11, 19)
  if (['1', '9', '11', '19'].includes(nudgeId)) {
    return styles.spending;
  }
  // Savings nudges (2, 7, 17)
  if (['2', '7', '17'].includes(nudgeId)) {
    return styles.savings;
  }
  // Goal nudges (3, 15, 18)
  if (['3', '15', '18'].includes(nudgeId)) {
    return styles.goal;
  }
  // Alert nudges (5, 13, 14)
  if (['5', '13', '14'].includes(nudgeId)) {
    return styles.alert;
  }
  // Peer comparison nudges (16) - use a distinct style
  if (['16'].includes(nudgeId)) {
    return styles.savings;
  }
  return '';
};

const NudgeItem: React.FC<{
  nudge: Nudge;
  onclick: any;
}> = ({ nudge, onclick }) => {
  const labelContent =
    typeof nudge.label === 'string' ? nudge.label : String(nudge.label || '');

  const themeClass = getThemeClass(nudge.id);

  return (
    <div
      className={`${styles.nudge} ${themeClass}`}
      onClick={() => {
        onclick(nudge);
      }}
    >
      <div className={styles.nudgeContent}>
        <div className={styles.iconWrapper}>{getIcon(nudge)}</div>
        <div className={styles.textContent}>
          <Typography.Text className={styles.nudgeLabel}>
            {parse(labelContent, { trim: false })}
          </Typography.Text>
          <Typography.Text className={styles.tapHint}>
            Tap to learn more
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default NudgeItem;
